"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReclaimAddressAllOfToJSON = exports.ReclaimAddressAllOfFromJSONTyped = exports.ReclaimAddressAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
function ReclaimAddressAllOfFromJSON(json) {
    return ReclaimAddressAllOfFromJSONTyped(json, false);
}
exports.ReclaimAddressAllOfFromJSON = ReclaimAddressAllOfFromJSON;
function ReclaimAddressAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'salutation': !(0, runtime_1.exists)(json, 'salutation') ? undefined : json['salutation'],
        'honorific': !(0, runtime_1.exists)(json, 'honorific') ? undefined : json['honorific'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}
exports.ReclaimAddressAllOfFromJSONTyped = ReclaimAddressAllOfFromJSONTyped;
function ReclaimAddressAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'salutation': value.salutation,
        'honorific': value.honorific,
        'firstName': value.firstName,
        'lastName': value.lastName,
    };
}
exports.ReclaimAddressAllOfToJSON = ReclaimAddressAllOfToJSON;
//# sourceMappingURL=ReclaimAddressAllOf.js.map